module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="detail_wkfhisto_sp">\r\n</span>\r\n';
}
return __p;
};
